module.exports = __webpack_public_path__ + "static/media/noPhoto-big.48ee9103.png";